'use strict';

let module = {};

let routes = function ($stateProvider, baseState) {

    require('./routes.js').default.routes($stateProvider, '' + baseState + '');

    $stateProvider

        .state(baseState + '.clerk-fiscal-years.existing.edit.accounting-setup', {
            url: "/accounting-setup",
            template: require("./steps/accounting-setup.html"),
            data: {stepCation: 'Accounting setup'}
        })

    ;

};

module.routes = routes;

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-fiscal-year/customized-routes.js